
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";
import MenuBookHeader from "./menu-book-header.vue";
import MenuBookMenuList from "./menu-book-menu-list.vue";
import BrandSwitchDialog from "../dialogs/brand-switch-dialog.vue";
export default {
  components: { MenuBookHeader, MenuBookMenuList, BrandSwitchDialog },
  data() {
    return {
      showBrandSwitchDialog: false
    };
  },
  beforeMount() {
    this.SET_SELECTED_GROUP_BY_MENU("category");
  },
  async fetch() {
    this.SET_MENU_LOADING(true);
    await Promise.all([
      this.getCategories({ forceFetch: true }),
      this.getMenuList(true),
      this.getAddons({ forceFetch: true }),
      this.getTaxes()
    ]);
    this.SET_MENU_LOADING(false);
  },
  computed: {
    ...mapGetters("restaurant", ["getRestaurantDetailedInfo"]),
    ...mapState("restaurant", ["locationDetails"]),
    ...mapState("menu", ["menuLoading", "menuItems"]),
    brandId() {
      return this.$route.params.brand;
    },
    locationId() {
      return this.$route.params.location;
    },
    restaurantInfo() {
      return this.getRestaurantDetailedInfo(this.brandId);
    }
  },
  methods: {
    ...mapActions("menu", [
      "getMenuList",
      "getCategories",
      "getAddons",
      "getTaxes"
    ]),
    ...mapMutations("menu", ["SET_MENU_LOADING", "SET_SELECTED_GROUP_BY_MENU"]),
    handleBrandSwitch(brandId) {
      this.$router.push(`/${this.$route.params.location}/${brandId}/menu`);
    }
  }
};
